import { COMPLETE_REGISTRATION } from '@core/constants';
import UserNotification from '@models/user/notifications/UserNotification';
import { NotificationType } from '@models/user/enums';
import User from '@models/user/User';
import { addIdCard, addSms } from '@modules/userProfile/notifications/utils';
import config from '@config';
import DateUtils from '@utils/date/DateUtils';

export function getNotifications(user: User): UserNotification[] {
    const notifications: UserNotification[] = [];

    if (!user.bankAccount) {
        notifications.push({
            title: COMPLETE_REGISTRATION,
            type: NotificationType.completeRegistration
        });
    } else if (!user.isVerifiedIdCard) {
        addIdCard(user, notifications);
    }

    addSms(user, notifications);
    return notifications;
}

export function idCardRemainingDays(user: User): number {
    return Math.max(
        0,
        config.countrySpecific.user.idCardVerification.period
        - DateUtils.differenceInDays(new Date(), user.registrationDate)
    );
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/terminal/poland/core/models/user/UserDataService.ts